import { render, staticRenderFns } from "./DatatableControl.vue?vue&type=template&id=8b57cf90&"
import script from "./DatatableControl.vue?vue&type=script&lang=js&"
export * from "./DatatableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports